import { useState, useEffect } from 'react'

function getApiBase() {
  const h = window.location.hostname
  if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:3000/api/v1'
  if (h.endsWith('.eatbridge.com')) {
    const sub = h.replace(/\.eatbridge\.com$/, '')
    if (sub.startsWith('staging.') || h === 'staging.eatbridge.com') {
      return 'https://api-staging.eatbridge.com/api/v1'
    }
    return 'https://api.eatbridge.com/api/v1'
  }
  return import.meta.env.VITE_API_URL || 'https://api.eatbridge.com/api/v1'
}

function getSlug() {
  const h = window.location.hostname
  if (h.endsWith('.eatbridge.com')) {
    const sub = h.replace(/\.eatbridge\.com$/, '')
    // exclude known non-restaurant subdomains
    if (!['www', 'app', 'app-staging', 'staging', 'api', 'api-staging'].includes(sub)) {
      return sub
    }
  }
  const params = new URLSearchParams(window.location.search)
  return params.get('slug') || import.meta.env.VITE_SLUG || null
}

export function useRestaurantData() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [slug] = useState(() => getSlug())

  useEffect(() => {
    if (!slug) { setLoading(false); return }

    const apiBase = getApiBase()
    fetch(`${apiBase}/public/shops/${slug}`, {
      headers: { 'X-App': 'eatbridge' },
    })
      .then(r => {
        if (!r.ok) throw new Error(`Restaurant not found`)
        return r.json()
      })
      .then(json => {
        // server wraps responses in { success, data, ... }
        const payload = json?.success !== undefined ? json.data : json
        setData(payload)
      })
      .catch(setError)
      .finally(() => setLoading(false))
  }, [slug])

  return { data, loading, error, slug }
}
